__turbopack_context__.v({
  "crossfade": "JuoxLq_crossfade",
  "fadeIn": "JuoxLq_fadeIn",
  "fadeOut": "JuoxLq_fadeOut",
  "incoming": "JuoxLq_incoming",
  "outgoing": "JuoxLq_outgoing",
  "shimmer": "JuoxLq_shimmer",
  "text-bar-sweep": "JuoxLq_text-bar-sweep",
});
